"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import MemeDropTrait from "./MemeDropTrait";
import { FIELD_TO_LABEL_MAP, MEME_TRAITS_SORT_ORDER } from "@/components/waves/memes/traits/schema";
interface MemeDropTraitsProps {
  readonly drop: ApiDrop;
}
interface MemeDropTrait {
  label: string;
  value: string;
}
const MemeDropTraits: React.FC<MemeDropTraitsProps> = t0 => {
  const $ = _c(15);
  const {
    drop
  } = t0;
  const [showAllTraits, setShowAllTraits] = useState(false);
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== drop.metadata || $[1] !== showAllTraits) {
    const traits = drop.metadata.sort(_temp);
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = e => {
        e.stopPropagation();
        setShowAllTraits(false);
      };
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    const handleShowLess = t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = e_0 => {
        e_0.stopPropagation();
        setShowAllTraits(true);
      };
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    const handleShowAll = t6;
    t4 = "lg:tw-flex tw-flex-col tw-gap-2 tw-hidden tw-p-4";
    t1 = "tw-grid tw-grid-cols-2 sm:tw-grid-cols-4 tw-gap-2";
    t2 = traits.slice(0, 2).map(_temp2);
    t3 = showAllTraits ? <>{traits.slice(2).map(_temp3)}<button onClick={handleShowLess} className="tw-text-xs tw-text-primary-400 desktop-hover:hover:tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out tw-font-semibold tw-bg-transparent tw-border-0 tw-text-left">Show less</button></> : <button onClick={handleShowAll} className="tw-text-xs tw-text-primary-400 desktop-hover:hover:tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out tw-font-semibold tw-bg-transparent tw-border-0 tw-text-left">Show all</button>;
    $[0] = drop.metadata;
    $[1] = showAllTraits;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t5 = <div className={t1}>{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default MemeDropTraits;
function _temp(a, b) {
  const aIndex = MEME_TRAITS_SORT_ORDER.indexOf(a.data_key);
  const bIndex = MEME_TRAITS_SORT_ORDER.indexOf(b.data_key);
  return aIndex - bIndex;
}
function _temp2(trait) {
  return <MemeDropTrait key={trait.data_key} label={FIELD_TO_LABEL_MAP[trait.data_key as keyof typeof FIELD_TO_LABEL_MAP]} value={trait.data_value ?? ""} />;
}
function _temp3(trait_0) {
  return <MemeDropTrait key={trait_0.data_key} label={FIELD_TO_LABEL_MAP[trait_0.data_key as keyof typeof FIELD_TO_LABEL_MAP]} value={trait_0.data_value ?? ""} />;
}